import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-policy',
  templateUrl: './password-policy.component.html',
  styleUrls: ['./password-policy.component.scss']
})
export class PasswordPolicyComponent implements OnInit {
    MIN_LENGTH: number = 10;
  constructor() { }

  ngOnInit() {
  }

}
